import { useContext } from 'react'
import { AuthContext } from '@/contexts/AuthContext'
import type { AuthContextValue, Session } from '@/contexts/AuthContext'

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within AuthContext.Provider')
  return ctx
}

export function useSession(): Session {
  const { session } = useAuth()
  if (!session) throw new Error('useSession must be used when authenticated')
  return session
}
